module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAdklEQVR42u3asQ0AIAhFwT+Uyzk9bqCFjZEjeQNwFQWpqnQuAAAAAAAAAAAAAAAAuJqMue3BAQAAAAAAAAAAAAAAAAAAANoDnBb4LQAAAAAAAACAQwgAAAAAAAAAAAAAAAAAAABoDuBTFAAAAAAAAAAAAACAPi0bxIOPnHoGfQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/Finland.png
// module id = w5Ij
// module chunks = 0 62 63